export const formatOptions = (
  options?: Array<{ label: string; value: string }>
): Record<string, string> => {
  if (!options) return {};

  return options.reduce(
    (acc, option) => ({
      ...acc,
      [option.value]: option.label,
    }),
    {}
  );
};
